module.exports = __webpack_public_path__ + "static/media/loginBackground.0ed25b9a.png";